<div class="page-container gap-24 font-color-black">
  <div class="page-title">Teilnahmebedingungen für unsere Fortbildungen</div>

  <p class="font-regular-body-large">
    Unsere Fortbildungen leben von einer offenen Lernatmosphäre, einem
    respektvollen Miteinander und einem professionellen Rahmen. Damit
    Präsenzkurse, Online Seminare und digitale Angebote für alle Beteiligten gut
    gelingen, haben wir die wichtigsten Teilnahmebedingungen hier für Dich
    zusammengefasst.
  </p>

  <p class="font-regular-body-large">
    Die folgenden Regelungen ergänzen unsere Allgemeinen Geschäftsbedingungen.
    Sie beschreiben unter anderem, wie Räumlichkeiten, Materialien, digitale
    Zugänge und Kursinhalte genutzt werden dürfen und welche Regeln für den
    gemeinsamen Lernraum gelten.
  </p>

  <p class="font-regular-body-large">
    Mit Deiner Anmeldung erkennst Du diese Teilnahmebedingungen an. Bitte nimm
    Dir vor Kursbeginn kurz Zeit, sie durchzulesen. So starten wir gemeinsam gut
    vorbereitet in die Fortbildung.
  </p>

  <span class="title-level-2">
    Bedingungen für die Teilnahme an Online- und Präsenz-Angeboten
  </span>

  <p class="font-regular-body-large">
    von Institut Wissen gemeinnützige UG (haftungsbeschränkt), nachfolgend
    „Veranstalter" genannt:
  </p>

  <span class="title-level-2">1. Allgemeine Teilnahmebedingungen</span>
  <div class="font-regular-body-large">
    <ul>
      <li>
        Bild-, Ton- und Videoaufzeichnungen des Kurses sind ohne vorherige
        ausdrückliche Zustimmung des Veranstalters nicht gestattet.
      </li>
      <li>
        Das Mitschneiden, Fotografieren, Abfilmen, Speichern oder
        Weiterverbreiten von Kursinhalten, Präsentationen, Materialien,
        Chatverläufen oder Aufzeichnungen ist nicht gestattet, soweit der
        Veranstalter dies nicht ausdrücklich freigegeben hat.
      </li>
      <li>
        Zur Verfügung gestellte Kursunterlagen, Arbeitsmaterialien,
        Präsentationen, Handouts, Aufzeichnungen oder sonstige digitale Inhalte
        dürfen ausschließlich von der angemeldeten teilnehmenden Person und nur
        für eigene Fortbildungszwecke genutzt werden, falls nicht weiter
        spezifiziert. Eine Weitergabe, Veröffentlichung, Vervielfältigung oder
        öffentliche Zugänglichmachung an Dritte ist nicht gestattet, sofern
        keine ausdrückliche Zustimmung des Veranstalters vorliegt.
      </li>
      <li>
        Die Teilnehmenden verpflichten sich, Persönlichkeitsrechte, Datenschutz
        und Vertraulichkeit im Kurs zu wahren. Inhalte, Fallbeispiele, Beiträge
        oder Äußerungen anderer Teilnehmender dürfen nicht ohne deren Zustimmung
        aufgezeichnet, gespeichert, weitergegeben oder veröffentlicht werden.
      </li>
      <li>
        Der Veranstalter ist berechtigt, Teilnehmende bei erheblichen Störungen
        des Kurses, missbräuchlicher Nutzung der technischen Funktionen oder
        unbefugter Weitergabe von Zugangsdaten vorübergehend oder dauerhaft vom
        Kurs auszuschließen. Weitergehende gesetzliche Ansprüche bleiben
        unberührt.
      </li>
    </ul>
  </div>

  <span class="title-level-2"
    >2. Teilnahmebedingungen bei Kursen in Präsenz</span
  >
  <div class="font-regular-body-large">
    <ul>
      <li>
        Die Teilnehmenden verpflichten sich, die Räumlichkeiten,
        Einrichtungsgegenstände, Geräte und Materialien der Praxis sorgsam zu
        behandeln. Für von ihnen vorsätzlich oder fahrlässig verursachte Schäden
        haften die Teilnehmenden nach den gesetzlichen Vorschriften unmittelbar
        gegenüber der geschädigten Person oder Stelle.
      </li>
      <li>
        Die Nutzung von Praxisgeräten, Therapiematerialien, Behandlungsliegen,
        technischen Geräten oder sonstigem Inventar ist nur gestattet, soweit
        dies im Rahmen des Kurses ausdrücklich freigegeben wird.
      </li>
      <li>Nicht freigegebene Praxisbereiche dürfen nicht betreten werden.</li>
      <li>
        Die Teilnehmenden haben den Hinweisen des Veranstalters, der
        Dozent*innen und der Praxis zur Nutzung der Räumlichkeiten Folge zu
        leisten.
      </li>
    </ul>
  </div>

  <span class="title-level-2"
    >3. Teilnahmebedingungen bei Online-Angeboten</span
  >
  <div class="font-regular-body-large">
    <ul>
      <li>
        Die Teilnehmenden sind selbst dafür verantwortlich, die technischen
        Voraussetzungen für die Teilnahme am Online Angebot zu schaffen. Hierzu
        gehören insbesondere eine stabile Internetverbindung, ein geeignetes
        Endgerät, ein aktueller Browser oder die erforderliche Software sowie
        eine funktionierende Audio- und bei Bedarf Videofunktion.
      </li>
      <li>
        Die Zugangsdaten zum Online Angebot sind personenbezogen und dürfen
        nicht an Dritte weitergegeben werden. Eine Teilnahme durch nicht
        angemeldete Personen ist nicht gestattet.
      </li>
      <li>
        Die Teilnehmenden verpflichten sich, den digitalen Kursraum nur im
        Rahmen des gebuchten Angebots zu nutzen und technische Funktionen wie
        Chat, Mikrofon, Kamera, Bildschirmfreigabe oder Dateiübertragung nur
        kursbezogen einzusetzen.
      </li>
      <li>
        Die Teilnehmenden haben den Hinweisen des Veranstalters und der
        Dozent*innen zur Nutzung des Online Kursraums Folge zu leisten.
      </li>
    </ul>
  </div>

  <span class="title-level-2"
    >4. Nutzungsbedingungen Seminar-Aufzeichnungen</span
  >
  <div class="font-regular-body-large">
    <ul>
      <li>
        Sofern der Veranstalter eine Aufzeichnung des Online Angebots erstellt
        oder bereitstellt, erfolgt dies nur nach Maßgabe der hierfür geltenden
        Hinweise und Einwilligungen. Die Teilnehmenden werden vorab darüber
        informiert, ob eine Aufzeichnung erfolgt und in welchem Umfang Bild-,
        Ton-, Chat- oder Namensdaten verarbeitet werden.
      </li>
      <li>
        Eine durch den Veranstalter bereitgestellte Aufzeichnung darf
        ausschließlich von der angemeldeten teilnehmenden Person für eigene
        Fortbildungszwecke genutzt werden. Eine Weitergabe, Veröffentlichung,
        Vervielfältigung, Bearbeitung oder öffentliche Zugänglichmachung der
        Aufzeichnung ist nicht gestattet, sofern der Veranstalter dies nicht
        ausdrücklich freigegeben hat.
      </li>
    </ul>
  </div>
</div>
